import React from 'react'
import HealthInformation from './HealthInformation'

export default function Disability () {
  return <HealthInformation path='disability' />
}